"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProvidedPort = void 0;
/**
 * SOLID Review
 * S — Strong. Solely wraps a concrete implementation and returns it via getInterface(); no routing,
 *     transformation, or lifecycle logic.
 * O — Strong. Accepts any implementation T at construction time; no modification needed when T changes.
 * L — Strong. Substitutable for Port<T> wherever a port reference is expected; getInterface() always
 *     returns a valid, non-null value consistent with the base contract.
 * I — Strong. Extends Port<T> with no added public members beyond what the base declares.
 * D — Strong. Depends on the abstract Port<T> base; the implementation it wraps is injected, not created
 *     here.
 */
const Port_1 = require("./Port");
/**
 * Provided port — the lollipop notation in UML component diagrams.
 *
 * The component exposes a concrete implementation through this port.
 * Other components connect to it via a Connector after wiring a RequiredPort.
 *
 * Usage (in a Component class):
 *   readonly playerRepositoryPort = new ProvidedPort<IPlayerRepository>('PlayerRepository', new PlayerRepository(orm));
 */
class ProvidedPort extends Port_1.Port {
    implementation;
    /**
     * The lollipop carries the contract too, so that `RequiredPort.connect()` can compare digests: a
     * socket declared against one revision of a contract must not accept a supplier built against
     * another. The implementation itself is handed out unguarded — it is the SOCKET that guards, at
     * the point of use, because the socket is where the consumer's expectations live.
     */
    constructor(name, implementation, contract = null) {
        super(name, contract);
        this.implementation = implementation;
    }
    getInterface() {
        return this.implementation;
    }
}
exports.ProvidedPort = ProvidedPort;
//# sourceMappingURL=PortProvided.js.map